<template>
  <div>
    <section v-if="header" class="kc-elm kc-css-701638 kc_row">
      <div class="kc-row-container">
        <div class="kc-wrap-columns">
          <div class="kc-elm kc-css-376091 kc_col-sm-12 kc_column kc_col-sm-12">
            <div class="kc-col-container">
              <div class="ssc_mltttl kc-elm kc-css-502498 title_intro_page">
                <h1 class="wr deb decb dea dela line nonea">
                  <span class="ssc-subtitle">{{title}}</span>
                </h1>
              </div>
              <div class="ssc-breadcrumbs kc-elm kc-css-172824">
                <span class="ssc-subtitle">{{subtitle}}</span>
              </div>
              <div class="bgrlabel kc-elm kc-css-428468" style="left:70px;bottom:-59px;">
                <div class="inside_wrap">
                  <div class="imgl">
                    <img
                      src="../../assets/images/Cover_01.png"
                      alt
                    />
                  </div>
                </div>
              </div>
              <div class="bgrlabel kc-elm kc-css-642519" style="bottom:-59px;right:142px;">
                <div class="inside_wrap">
                  <div class="imgl">
                    <img
                      src="../../assets/images/Image-right.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <article class="post-3487 page type-page status-publish hentry">
      <div class="container-full">
        <div class="entry-content">
          <slot></slot>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: "Article",
  props: ["title", "subtitle", "header"],
  data() {
    return {
      msg: "Article"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/layout/Article.vue